export * from '@primeuix/themes/nora/splitter';
export { default } from '@primeuix/themes/nora/splitter';
